<div class="container row-centered logo-and-colors big-gapped">
    <div class="row row-centered gapped">
        <div class="logo-col">
            <app-file-drop
                [accepts]="['.svg', '.png', '.jpg', '.jpeg']"
                [uploadAPI]="null"
                [extraData]="{ updateBothLogos: true }"
                [hideUpload]="true"
                [image]="logo"
                [text]="'Upload Your Logo'"
                [tooltipText]="'Click to upload logo'"
                [minifiedImageUpload]="true"
                [toUploadWhenDropped]="false"
                (filedropped)="onFileDroppedAsync($event, true)"
                (uploadFinished)="uploadingLogo()"></app-file-drop>
        </div>
    </div>
    <div class="pickers column-centered gapped" *ngIf="branding?.colors">
        <div class="column-centered" [matTooltip]="'Pick Primary Color'">
            Primary Color
            <div>
                <app-color-pallet
                    [color]="branding.colors.colorPrimary"
                    [displayBrandColors]="false"
                    [key]="'colorPrimary'"
                    (colorChanged)="brandingColorChanged($event)"></app-color-pallet>
            </div>
        </div>
        <div class="column-centered" [matTooltip]="'Pick Secondary Color'">
            Secondary Color
            <div>
                <app-color-pallet
                    [color]="branding.colors.colorExtra"
                    [displayBrandColors]="false"
                    [key]="'colorExtra'"
                    (colorChanged)="brandingColorChanged($event)"></app-color-pallet>
            </div>
        </div>
    </div>
</div>
